import React from 'react';
import {
  useNavigate,
} from 'react-router-dom';
import {
  shallowEqual,
  useDispatch,
  useSelector,
} from 'react-redux';
import {
  Formik,
  Field,
} from 'formik';
import MobileDetect from 'mobile-detect';
import * as Yup from 'yup';

import {
  coreActions,
  coreSelectors,
} from '@gymcloud/core';

import {
  data,
} from 'web-utils';
import {
  getUiState,
} from 'web-selectors';

import {
  Flex,
  Text,
  icons,
} from 'web-styled';

import {
  SelectField,
  DatePickerField,
  UploadPhoto,
} from 'web-components';

import * as S from './styled';

const validationSchema = Yup.object().shape({
  business_type: Yup.string()
    .required('Required'),
  user_type: Yup.string()
    .required('Required'),
  clients_count: Yup.string()
    .required('Required'),
});

const fields = [
  {
    label: 'What best describes your business? *',
    name: 'business_type',
    options: data.businessTypeOptions,
  },
  {
    label: 'What best describes you? *',
    name: 'user_type',
    options: data.userTypeOptions,
  },
  {
    label: 'How many clients/members do you currently have? *',
    name: 'clients_count',
    options: data.clientCountOptions,
  },
];

const mapState = state => ({
  user: coreSelectors.getProfile(state),
  fileUpload: getUiState('fileUpload')(state),
});

const HTSProfileSetup = () => {
  const {
    user,
    fileUpload,
  } = useSelector(mapState, shallowEqual);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const onSubmit = (payload, actions) => {
    const md = new MobileDetect(window.navigator.userAgent);
    dispatch(
      coreActions.profileSetupRequest({
        payload,
        settings: {
          is_completed_profile_customization: true,
        },
        callbacks: {
          ...actions,
          onSuccess: () => {
            navigate(md.mobile() ? '/get_app' : '/welcome');
          },
        },
      }),
    );
  };

  return (
    <S.MainContainer>
      <Text color="#fff" size="30px" weight="800">
        Customize Your Profile
      </Text>
      <Formik
        onSubmit={onSubmit}
        initialValues={{
          birthday: '',
          gender: null,
          business_type: '',
          user_type: '',
          clients_count: '',
          primary_goal: 'any',
        }}
        validationSchema={validationSchema}
      >
        {(formikProps) => (
          <S.FormContainer onSubmit={formikProps.handleSubmit}>
            <Flex>
              <UploadPhoto
                width={150}
                height={150}
                src={user.user_profile?.avatar?.large?.url}
                placeholder={icons.clientAvatarPlaceHolder}
                uploadProgress={fileUpload[user.user_profile?.id]?.progress || 0}
                onChange={(file) => {
                  dispatch(
                    coreActions.requestUploadClientAvatar({
                      file,
                      profileId: user.user_profile?.id,
                    }),
                  );
                }}
                setPhotoPreview={() => {}}
              />
            </Flex>
            <S.FieldContainer>
              <Text
                color="#000"
                weight={800}
                size="15px"
              >
                Birthday
              </Text>
              <Field
                name="birthday"
                placeholderText="Your Birthday"
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                component={DatePickerField}
              />
            </S.FieldContainer>
            <S.FieldContainer>
              <Text
                color="#000"
                weight={800}
                size="15px"
              >
                Gender
              </Text>
              <Field
                name="gender"
                options={data.genderOptions}
                component={SelectField}
                isSearchable={false}
                placeholder="-- Select Your Gender --"
                theme={{
                  borderRadius: 5,
                }}
                styles={{
                  option: provided => ({
                    ...provided,
                    fontSize: '14px',
                    lineHeight: '12px',
                    fontWeight: 500,
                  }),
                  valueContainer: provided => ({
                    ...provided,
                    fontSize: '15px',
                    lineHeight: '15px',
                    fontWeight: 500,
                  }),
                }}
              />
            </S.FieldContainer>

            {fields.map(field => (
              <S.FieldContainer key={field.name}>
                <Text
                  color="#000"
                  weight={800}
                  size="15px"
                >
                  {field.label}
                </Text>
                <Field
                  name={field.name}
                  options={field.options}
                  component={SelectField}
                  isSearchable={false}
                  maxMenuHeight={160}
                  theme={{
                    borderRadius: 5,
                  }}
                  styles={{
                    valueContainer: provided => ({
                      ...provided,
                      fontSize: '15px',
                      lineHeight: '15px',
                      fontWeight: 500,
                    }),
                  }}
                />
              </S.FieldContainer>
            ))}

            <S.SubmitButton
              isLoading={formikProps.isSubmitting}
              isDisabled={formikProps.isSubmitting}
            >
              Save
            </S.SubmitButton>
          </S.FormContainer>
        )}
      </Formik>
    </S.MainContainer>
  );
};

export default HTSProfileSetup;
